

class SeStoreDTO {
    criteria: string[]
    capacity: string
    engineId: number
    rc_size: string
    rc_start: string
    parentStation?: number[]
    station?: number[]
    region?:string
    domaineSki?: string
    beginDate?: string
    endDate?: string
    packages?: string[]
    lodgingType?:string[]
    constructor(
        seStore: {
            criteria: string[],
            capacity: string,
            engineId: number,
            rc_size: string,
            rc_start: string,
            parentStation?: number[],
            station?: number[],
            region?:string,
            domaineSki?: string,
            beginDate?: string,
            endDate?: string,
            packages?: string[],
            lodgingType?:string[]
        }
    ){
        this.criteria = seStore.criteria
        this.capacity = seStore.capacity
        this.engineId = seStore.engineId
        this.rc_size = seStore.rc_size
        this.rc_start = seStore.rc_start
        this.parentStation = seStore.parentStation
        this.station = seStore.station
        this.region = seStore.region
        this.domaineSki = seStore.domaineSki
        this.beginDate = seStore.beginDate
        this.endDate = seStore.endDate
        this.packages = seStore.packages
        this.lodgingType = seStore.lodgingType
    }
}

export default SeStoreDTO